module.exports = __webpack_public_path__ + "img/user_photo.f8cbf3db.jpg";